<template>
  <crud-list
    :datasource="datasource"
    :capabilities="capabilities"
    @item-selected="selectedItemTraitements"
    :callRefresh="callRefresh"
    ref="datasourceRef"
  >
    <template #search>
      <search-by
        :datasource="datasource"
        attr="nomContactEtablissement"
        @emitsearchby="emitsearchby"
      />
      <search-by
        :datasource="datasource"
        attr="prenomContactEtablissement"
        @emitsearchby="emitsearchby"
      />
      <search-by
        :datasource="datasource"
        attr="idSearchEtablissement"
        @emitsearchby="emitsearchby"
      />
      <search-by
        :datasource="datasource"
        attr="raisonSocialEtablissement"
        @emitsearchby="emitsearchby"
      />
      <search-by
        :datasource="datasource"
        attr="searchEntrepriseInsee"
        :check="true"
        @emitsearchby="emitsearchby"
      />
    </template>
  </crud-list>
</template>

<script>
import Datasource from '@/utils/datasource'

export default {
  props: {
    fieldName: {
      type: String,
      default: '_link',
    },
    rowsSize: {
      type: Number,
      default: 15,
    },
    callRefresh: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.$nextTick(function () {
      // this.datasource.args.idTechnique = this.$auth.idTechnique();
      this.datasource.refresh()
    })
  },
  data() {
    const datasource = new Datasource('correspondant', {
      page: 1,
      rowsPerPage: this.rowsSize,
      sortBy: '',
      descending: false,
      args: { actif: true },

      linkClass: (item) => (item.actif ? '' : 'inactif'),
      fields: [
        {
          value: 'id',
          text: this.$t('correspondant.list.headers.id'),
          linkTo: this.linkTo,
          sortable: true,
        },
        {
          value: 'contact.civilite.label',
          text: this.$t('correspondant.list.headers.civilite'),
          sortable: true,
        },
        {
          value: 'contact.name',
          text: this.$t('correspondant.list.headers.name'),
          sortable: true,
        },
        {
          value: 'contact.mail',
          text: this.$t('correspondant.list.headers.mail'),
          sortable: true,
        },
        {
          value: 'contact.telFixe',
          text: this.$t('correspondant.list.headers.telfixe'),
          sortable: true,
        },
        {
          value: 'contact.telPortable',
          text: this.$t('correspondant.list.headers.telPortable'),
          sortable: true,
        },
        {
          value: 'etablissement.raisonSociale',
          text: this.$t(
            'correspondant.list.headers.etablissementRaisonSociale',
          ),
          sortable: true,
        },
        {
          value: 'entrepriseInseeExtraciem.raisonSociale',
          text: this.$t('correspondant.list.headers.entrepriseRaisonSociale'),
          sortable: true,
        },
        {
          value: 'groupement.raisonSociale',
          text: this.$t('correspondant.list.headers.groupementRaisonSociale'),
          sortable: true,
        },
      ],
    })
    return {
      datasource,
    }
  },
  computed: {
    capabilities() {
      if (this.$auth.hasRole('ROLE_CORRESPONDANT')) {
        return 'search'
      } else {
        return ''
      }
    },
  },
  methods: {
    selectedItemTraitements(item) {
      this.$emit('item-selected', item)
    },

    emitsearchby(attr, value) {
      this.datasource.args[attr] = value
    },
  },
}
</script>
